import { Helmet } from 'react-helmet'
import MainImage1 from '../../assets/about-us/about-us-1.webp'
import MainImage2 from '../../assets/about-us/about-us-2.webp'
import MainImage3 from '../../assets/about-us/about-us-3.webp'
import Banner from '../../components/Banner'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay } from 'swiper/modules'
import Image1 from '../../assets/about-us/about-carousel-1.webp'
import Image2 from '../../assets/about-us/about-carousel-2.webp'
import Image3 from '../../assets/about-us/about-carousel-3.webp'
import Image4 from '../../assets/about-us/about-carousel-4.webp'
import Image5 from '../../assets/about-us/image-5.webp'
import Image6 from '../../assets/about-us/image-6.webp'
import Vidita from '../../assets/brand/Vidita'
import VideoBanner from '../../components/VideoBanner'
import WhatsAppButton from '../../components/WhatsAppButton'
import WorkWithUs from '../../containers/WorkWithUs'

const IMAGES = [
  Image1,
  Image2,
  Image3,
  Image4,
  Image5,
  Image6
]

const AboutUs = () => {
  return (
    <>
      <Helmet>
        <title>Vida Cowork: Nosotros</title>
      </Helmet>

      <main className="AboutUs">
        <Banner
          title='Nosotros'
          description='Somos una experiencia de trabajo flexible y profesional rodeada de naturaleza.'
          message='¡Hola! Quisiera realizar un día de prueba en Vida'
          whatsappIconLeft
        />
        <section className="AboutUs__Info container-custom">
          <div className="AboutUs__Info-Item">
            <div className="d-flex flex-column gap-3">
              <span className='title-2 text-green fw-medium'>
                ¿Quiénes somos?
              </span>
              <span className='text-4'>
                Creamos espacios de trabajo estratégicos y flexibles donde la eficiencia corporativa se combina con la calidez humana.
              </span>
              <span className='text-4'>
                Ofrecemos un servicio cercano y resolutivo para equipos que buscan potenciar productividad, bienestar y comunidad.
              </span>
            </div>

            <img
              className='AboutUs__Info-Image'
              src={MainImage1}
              alt="Vida Cowork"
              title="Vida Cowork"
            />
          </div>

          <div className="AboutUs__Info-Item">
            <img
              className='AboutUs__Info-Image'
              src={MainImage2}
              alt="Vida Cowork"
              title="Vida Cowork"
            />

            <div className="w-100 d-flex flex-column gap-3">
              <span className='title-2 text-green fw-medium'>
                Combinamos excelencia y estructura con un trato humano y cercano
              </span>
              <span className='text-4'>
                Nos adaptamos con agilidad, siempre enfocándonos en lo que realmente importa y suma.
              </span>
              <span className='text-4'>
                Promovemos entornos, vínculos y dinámicas que fortalecen cómo trabajamos y nos conectamos.
              </span>
              <span className='text-4'>
                Elevamos cada espacio, servicio y relación para dejar huella e impulsar una forma de trabajar más consciente y evolucionada. 
              </span>
            </div>
          </div>

          <div className="AboutUs__Info-Item">
            <div className="d-flex flex-column gap-3">
              <span className='title-2 text-green fw-medium'>
                ¿Por qué nos diferenciamos?
              </span>
              <span className="text-4">
                Porque entendemos el trabajo como una experiencia integral. Combinamos infraestructura de primer nivel con actividades que promueven el desarrollo personal y colectivo. Fomentamos una cultura que inspira, impulsa y transforma a los equipos, integrando el disfrute, la naturaleza y el propósito en la rutina laboral.
              </span>

              <div className="d-none d-md-block">
                <WhatsAppButton
                  label='Reservar ahora'
                  message='Hola! Quisiera realizar un día de prueba en Vida'
                  withIconLeft
                />
              </div>
            </div>

            <img
              className='AboutUs__Info-Image'
              src={MainImage3}
              alt="Vida Cowork"
              title="Vida Cowork"
            />

            <div className="d-block d-md-none">
              <WhatsAppButton
                label='Reservar ahora'
                message='Hola! Quisiera realizar un día de prueba en Vida'
              />
            </div>
          </div>
        </section>

        <section className="AboutUs__Slider-Container container-fluid">
          <div className="AboutUs__Slider-Tramas"></div>

          <div className="AboutUs__Slider container-custom">
            <Swiper
              className='AboutUs__Slider-Swiper'
              modules={[ Autoplay ]}
              slidesPerView={2}
              spaceBetween={16}
              autoplay={{
                delay: 5000,
                disableOnInteraction: false
              }}
              allowTouchMove={false}
              loop
              speed={1500}
              breakpoints={{
                768: {
                  slidesPerView: 3
                },
                1200: {
                  slidesPerView: 3,
                  spaceBetween: 24
                },
                // 1200: {
                //   slidesPerView: 3.5,
                // }
              }}
            >
              {IMAGES.map((image, index) => (
                <SwiperSlide key={`AboutUs-Slider-Image-${index}`}>
                  <img
                    className='AboutUs__Slider-Image'
                    src={image}
                    alt='Vida Cowork'
                    title='Vida Cowork'
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </section>

        <section className="AboutUs__CTA container-custom">
          <VideoBanner/>

          <div className="AboutUs__CTA-Text">
            <div className="AboutUs__CTA-Vidita">
              <h2 className="title">
              ¡Vení a conocernos y experimentá
              la diferencia!
              </h2>

              <WhatsAppButton
                label='Proba un día gratis'
                message='Hola! Quisiera realizar un día de prueba en Vida'
                withIcon
              />
            </div>
          </div>
        </section>

        <WorkWithUs/>
      </main>
    </>
  )
}

export default AboutUs